export default "__VITE_ASSET__DunUOBBq__"